import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { getNewestChangelogReleases } from '@webapp/platform/discover-more/business-logic/use-cases/getNewestChangelogReleases'
import { CHANGELOG_STALE_TIME_MS } from '@webapp/platform/discover-more/constants'
import { ChangelogRelease } from '@webapp/platform/discover-more/entities/ChangelogRelease'
import { changelogQueryConfig } from '@webapp/platform/discover-more/query-configs/changelog'

export const useQueryChangelogReleaseList = (limit: number) => {
  const { data, isLoading } = useQuery({
    ...changelogQueryConfig.getLatestReleases(),
    staleTime: CHANGELOG_STALE_TIME_MS,
    // The repository already falls back to its persisted copy, so a failure
    // here means there is nothing to show — retrying an unreachable marketing
    // site buys nothing.
    retry: false,
  })

  const releases = useMemo(
    () =>
      getNewestChangelogReleases({
        releases: (data ?? []).map((release) => new ChangelogRelease(release)),
        limit,
      }),
    [data, limit]
  )

  return {
    releases,
    isLoading,
  }
}
